import Loader from './assets/loader.gif';

import Backdrop from '@material-ui/core/Backdrop';

/**
 * Componente responsavel pelo carregamento do loader
 * @param {*} open responsavel por abrir o loader 
 * @returns loader.gif
 */
export const GeoBahiaLoader = ({ open, ...props }) => {
  return (
    <Backdrop style={{ zIndex: 2000, color: '#fff' }} open={open}>
      <img src={Loader} alt="Carregando..." style={{ width: '300px' }} />
    </Backdrop>
  );
};

export default GeoBahiaLoader;
